import { render, staticRenderFns } from "./NutritionalPollComponent.vue?vue&type=template&id=6b40ac78&"
import script from "./NutritionalPollComponent.vue?vue&type=script&lang=js&"
export * from "./NutritionalPollComponent.vue?vue&type=script&lang=js&"
import style0 from "./NutritionalPollComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports